import styled from '@emotion/styled'

export default styled('h5')`
  margin-bottom: 0;
  padding: 0;
`;
